import { Component, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { DialogService } from '../../../_services/dialog.service';
import { Vendor, VendorUser } from '../../../_models/fundraising/Vendor';
import { VendorService } from '../../../_services/fundraising/vendor.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FundraisingAccountLinkModalComponent } from '../fundraising-account-link-modal.component';

@Component({
  selector: 'app-vendor-management',
  templateUrl: './vendor-management.component.html',
  styleUrls: ['./vendor-management.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class VendorManagementComponent implements OnInit {

  searchText: string;
  vendors: VendorUser[] = [];
  displayItems: VendorUser[] = [];

  private bsModalRef: BsModalRef;

  constructor(
    private vendorService: VendorService,
    private dialogService: DialogService,
    public viewRef: ViewContainerRef,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    this.getVendors();
  }

  public createNew() {
    this.router.navigate([`create`], {relativeTo: this.route});
  }

  public createNewUser () {

    this.router.navigate(['create-user'], {relativeTo: this.route});
  }

  public delete(vendor: Vendor) {
    this.dialogService.confirm('Confirm Delete', 'Are you sure you want to delete this vendor?', this.viewRef)
      .then(result => {
        if (result) {
            this.deleteVendor(vendor.vendorId);
        }
    });
  }

  public edit(vendorUser: VendorUser) {
    this.router.navigate([`create/${vendorUser.vendor.vendorId}`], {relativeTo: this.route});
  }

  public resendPortalOnboardingUrl(vendor: Vendor) {
    this.dialogService.confirm(
      'Confirm Resend Portal Invite', 
      'Are you sure you want to resend the portal onboarding invite?', 
      this.viewRef)
    .then(result => {
      if (result) {
        this.spinner.show();
        this.vendorService.resendPortalOnboardingUrl(vendor.vendorId)
        .subscribe(
          () => {
            this.spinner.hide();
          },
          error => {
            this.spinner.hide();
            this.dialogService.alert('Error', `Unable to resend portal invite. Message: ${error.error}`, this.viewRef);
          }
        );
      }
    });
  }

  public getVendors() {
    this.spinner.show();
    this.vendorService.getAll().subscribe(
      data => {
        this.vendors = data;
        this.displayItems = data;
      },
      error => {
        this.dialogService.alert('Error', `Unable to get vendors. ${error.error}`, this.viewRef);
      },
      () => {
        this.spinner.hide();
      }
    );
  }

  public openAccountLinkModal(vendorId: number) {
    const modalConfig = {
        backdrop: true,
        ignoreBackdropClick: true
    };

    const initialState = {
      accountId: vendorId,
      accountType: 'vendor'
    };

    this.bsModalRef = this.modalService
      .show(
          FundraisingAccountLinkModalComponent,
          Object.assign({}, modalConfig, { class: 'modal-sm', initialState })
      );

    this.bsModalRef.content.hasError
      .subscribe(
        value => {
            if (value) {
              this.dialogService.alert('Error', `Unable to create account links`, this.viewRef);
            } else {
                this.getVendors();
            }
      });
  }

  public deleteVendorUser (vendorUserId: number) {

    const vendorUser = this.vendors.find(v => v.fundraisingVendorUserId === vendorUserId);

    this.dialogService.confirm("Are you sure?", 
      `Do you want to remove ${vendorUser?.user.firstName} ${vendorUser?.user.lastName} as a user from ${vendorUser?.vendor.name}?`,
      this.viewRef)
      .then(
        res => {

          if (res) {

            this.spinner.show();

            this.vendorService.deleteVendorUser(vendorUserId)
              .subscribe(
                _ => {

                  this.spinner.hide();
                  this.dialogService.alert("Success", "This user was successfully removed from the vendor group.", this.viewRef)
                    .then(
                      res => {

                        this.ngOnInit();
                      }
                    )
                },
                error => {

                  this.spinner.hide();
                  this.dialogService.alert("Uh oh!", "Something went wrong trying to remove the user from that vendor group.", this.viewRef);
                }
            )
          }
        }
      );
  }

  public search() {
    if (!this.searchText) {
      return;
    }

    const search = this.searchText.toLowerCase();
    this.displayItems = this.vendors.filter(d =>
      (d.vendor?.name ? d.vendor.name.toLowerCase().indexOf(search) !== -1 : false) ||
      (d.user?.email ? d.user.email.toLowerCase().indexOf(search) !== -1 : false) ||
      (d.vendor?.createdBy ? d.vendor.createdBy.toLowerCase().indexOf(search) !== -1 : false) ||
      (d.vendor?.modifiedBy ? d.vendor?.modifiedBy.toLowerCase().indexOf(search) !== -1 : false) );
  }
   
  private deleteVendor(vendorId: number) {
    this.spinner.show();
      this.vendorService.delete(vendorId)
      .subscribe(
        () => {
          this.spinner.hide();
          this.getVendors();
        },
        error => {
          this.spinner.hide();
          this.dialogService.alert('Error', `Unable to delete vendor. Message: ${error.error}`, this.viewRef);
        }
      ); 
  }

}
